import Grid2 from "@mui/material/Unstable_Grid2";
import React, { ReactElement } from "react";

export function StudentTab(props: { children: ReactElement | Array<ReactElement> }) {
  const children = React.Children.toArray(props.children);

  if (children.length < 1 || children.length > 2) {
    throw new Error(`Unexpect children.length: ${children.length} -- expected: 1 or 2`);
  }

  return (
    <div style={{ flex: 2 }}>
      {children.length === 1 && children[0]}
      {children.length === 2 && (
        <Grid2 container spacing="24px" /* see https://mui.com/material-ui/react-grid2 */>
          {children.map((child, index) => (
            <Grid2 flex="1 1 400px" key={index}>
              {child}
            </Grid2>
          ))}
        </Grid2>
      )}
    </div>
  );
}
